import { SelectItemType } from '@/types';
import { EUROPE_REGION_ID, NA_REGION_ID } from './serviceRegion.constants';

export const QUICK_FILTERS = {
  recent: 'recent',
  assignedMe: 'assignedMe',
  favorites: 'favorites',
  duplicates: 'duplicates',
};
export const quickFilterItems = [
  { value: QUICK_FILTERS.recent, name: 'Recently updated' },
  { value: QUICK_FILTERS.assignedMe, name: 'Assigned to me' },
  { value: QUICK_FILTERS.favorites, name: 'Show favorites only' },
  { value: QUICK_FILTERS.duplicates, name: 'Duplicates' },
];

export const CASE_TYPE_FILTERS = {
  opoRequest: 'opoRequest',
  isReallocatedFromSource: 'isReallocatedFromSource',
};

export const caseTypeFilterItems = [
  { value: CASE_TYPE_FILTERS.opoRequest, name: 'OPO' },
  { value: CASE_TYPE_FILTERS.isReallocatedFromSource, name: 'Re-allocation' },
];

export const serviceRegionItems: SelectItemType[] = [
  { value: EUROPE_REGION_ID, name: 'Europe' },
  { value: NA_REGION_ID, name: 'North America' },
];
